import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ColumnSelectProvider } from './Provider/ColumnSelectProvider';
import { ColumnSelectPanel, } from './ColumnSelectPanel';
/**
 * Wrap this component around your listgrid to provide a context
 * for adding and removing columns to/from the listgrid.
 *
 * ---
 *
 * > Note: should be paired with the useColumnSelect hook to provide
 * > access to the output data.
 *
 * ---
 *
 * > Todo: Add drag and drop ability to rearrange columns (and make it
 * accessible via buttons).
 *
 * ---
 *
 * @example // basic list
 * const MyDetailsList = (props)=>{
 *  const {selectedColumnList} = useColumnSelect()
 *  return <DetailsList items={items} columns={selectedColumnList}/>
 * }
 * <ColumnSelect allColumns={allColumns} defaultColumnKeyList={defaultColumnKeyList}>
 */
export const ColumnSelector = ({ children, defaultColumnKeyList, allColumnList, parentStorageKey, }) => (_jsxs(ColumnSelectProvider, Object.assign({ allColumnList: allColumnList, defaultColumnKeyList: defaultColumnKeyList, parentStorageKey: parentStorageKey }, { children: [children, _jsx(ColumnSelectPanel, {})] })));
